import React from "react";

import FormatUtils from "../utils/formatUtils";
import crossImg from "../images/xs.svg";

const ServiceTransactionHeader = (props) => (
  <>
    {props.title && (
      <div
        className={`service-transactions-popup-header ${
          props.popupChildClass || ""
        } fixed`}
      >
        <div className="close-icon" onClick={props.onClose}>
          <img src={crossImg} alt="close" />
        </div>
        <div className="title">{props.title}</div>
        <div className="delimeter" />
        {!props.hideInfo && props.policy && (
          <div className="policy-info">
            <div className="policy-info-data">
              Line of Business:
              <div className="policy-info-value">
                {props.policy.LineOfBusiness &&
                  props.policy.LineOfBusiness.Name}
              </div>
            </div>
            <div className="policy-info-data">
              Carrier:
              <div className="policy-info-value">
                {props.policy.BillingCarrierDisplayName}
              </div>
            </div>
            <div className="policy-info-data">
              Policy #:
              <div className="policy-info-value">
                {props.policy.PolicyNumber}
              </div>
            </div>
            <div className="policy-info-data">
              Policy Effective Date:
              <div className="policy-info-value">
                {props.policy.EffDate &&
                  FormatUtils.formatDate(props.policy.EffDate)}
              </div>
            </div>
            <div className="policy-info-data">
              Policy Expiration Date:
              <div className="policy-info-value">
                {props.policy.ExpDate &&
                  FormatUtils.formatDate(props.policy.ExpDate)}
              </div>
            </div>
          </div>
        )}
      </div>
    )}
  </>
);
export default ServiceTransactionHeader;
